/* eslint-disable @stripe-internal/embedded/no-restricted-globals */
// Shim from https://developers.google.com/web/updates/2015/08/using-requestidlecallback
function requestIdleCallbackShim(cb: IdleRequestCallback) {
  const start = Date.now();
  return window.setTimeout(function () {
    cb({
      didTimeout: false,
      timeRemaining() {
        return Math.max(0, 50 - (Date.now() - start));
      },
    });
  }, 1);
}

export const requestIdleCallbackPonyfill =
  typeof window !== 'undefined' && 'requestIdleCallback' in window
    ? window.requestIdleCallback
    : requestIdleCallbackShim;
